import _assign from "object-assign";

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useCallback, useRef, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import AriaAnnouncerContext from './AriaAnnouncerContext';
export var DELAY = 150;

var AriaAnnouncerProvider = function AriaAnnouncerProvider(_ref) {
  var children = _ref.children,
      style = _ref.style;

  var _useState = useState(''),
      currentAnnouncement = _useState[0],
      setCurrentAnnouncement = _useState[1];

  var announcementsRef = useRef([]);
  var isAnnouncingRef = useRef(false);
  var mountedRef = useRef(true);
  var announceAll = useCallback(function () {
    isAnnouncingRef.current = true;

    if (announcementsRef.current.length && mountedRef.current) {
      setCurrentAnnouncement('');
      requestAnimationFrame(function () {
        if (mountedRef.current) {
          var _announcementsRef$cur = _toArray(announcementsRef.current),
              announcement = _announcementsRef$cur[0],
              restAnnouncements = _announcementsRef$cur.slice(1);

          announcementsRef.current = restAnnouncements;
          setCurrentAnnouncement(announcement);
          setTimeout(function () {
            announceAll();
          }, DELAY);
        }
      });
    } else {
      isAnnouncingRef.current = false;
    }
  }, []);
  var announce = useCallback(function (announcement) {
    announcementsRef.current = announcementsRef.current.concat(announcement);

    if (!isAnnouncingRef.current) {
      announceAll();
    }
  }, [announceAll]);
  useEffect(function () {
    return function () {
      mountedRef.current = false;
    };
  }, []);
  var value = useMemo(function () {
    return {
      announce: announce
    };
  }, [announce]);
  return /*#__PURE__*/React.createElement(AriaAnnouncerContext.Provider, {
    value: value
  }, children, /*#__PURE__*/React.createElement("div", {
    "aria-atomic": "true",
    "aria-live": "assertive",
    // hidden styling based on https://webaim.org/techniques/css/invisiblecontent/
    style: _assign({
      clip: 'rect(1px, 1px, 1px, 1px)',
      clipPath: 'inset(50%)',
      height: 1,
      width: 1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      margin: -1
    }, style)
  }, currentAnnouncement));
};

process.env.NODE_ENV !== "production" ? AriaAnnouncerProvider.propTypes = {
  /**
   * Style overrides for the aria-live element
   */
  style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
} : void 0;
export default AriaAnnouncerProvider;